import { useMemo } from "react";
import { useSelector } from "react-redux";
import { makeSelectedDateIdFilterSelector } from "~/store/selectors/selector.configOptions";
import { makeAvailableDateFiltersByProjectIdSelector } from "~/store/selectors/selector.tasks";

export const useDueFilterData = (projectId) => {
  const getSelectedDateIdFilterSelector = useMemo(makeSelectedDateIdFilterSelector, []);
  const getDateFiltersByProjectId = useMemo(makeAvailableDateFiltersByProjectIdSelector, []);

  const selected = useSelector((state) => getSelectedDateIdFilterSelector(state, projectId));

  const availableDateFilters = useSelector((state) => getDateFiltersByProjectId(state, projectId));

  const options = useMemo(() => {
    const result = [];
    availableDateFilters.forEach((dateFilter) => {
      result.push({
        id: dateFilter.id,
        name: `${dateFilter.name}`,
        additionalInfo: `(${dateFilter.openTasksCount}/${dateFilter.completedTasksCount + dateFilter.openTasksCount})`,
      });
    });
    return result;
  }, [availableDateFilters]);

  return [selected, options];
};
